export default "__VITE_ASSET__DB38XvUN__"